import React, {useContext} from 'react';
import axios from 'axios';
import { API_URL, GENDER_GREETING_TEXT } from '../common/constants';
import { breakpoints } from "../stylesheets/variables";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import logo from '../assets/images/logo.svg';
import styled from 'styled-components';
import { colors } from '../stylesheets/variables';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useEffect, useState } from 'react';
import classnames from 'classnames';
import AuthContext from '../contexts/AuthContext';
import ModalContext from '../contexts/ModalContext';
import isEmpty from 'lodash/isEmpty';

const fetchData = async (url, token, onSuccess, onError) => {
  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (response.status === 200 && response.data.isSuccess) {
      onSuccess(response.data.result);
    } else {
      console.error(`Failed to fetch data from ${url}:`, response.data.message);
      onError && onError();
    }
  } catch (error) {
    console.error(`Error fetching data from ${url}:`, error);
    onError && onError();
  }
};

const RenderUnreadBadge = ({ unreadStatus, type }) => {
  const hasUnread = unreadStatus.some(item => item.notifytype === type && item.havenotify);
  return hasUnread ? <span className='red-point'></span> : null;
};

const RenderGreeting = ({ isAuth, memberInfo }) => {
  if (!isAuth || isEmpty(memberInfo) || !memberInfo?.name) return null;
  return (
    <StyledGreeting className="greeting">
      Hi, {memberInfo.name} {GENDER_GREETING_TEXT[memberInfo.gender]}
    </StyledGreeting>
  );
};

const Header = ({ handleLogout }) => {
  const [isSticky, setIsSticky] = useState(false);
  const [unreadStatus, setUnreadStatus] = useState([]);
  const { isAuth } = useContext(AuthContext);
  const { handleShow } = useContext(ModalContext);
  const [memberInfo, setMemberInfo] = useState({});

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (isAuth) {
      fetchData(`${API_URL}/api/unreadStatus`, token, setUnreadStatus, handleShow);
      fetchData(`${API_URL}/api/member`, token, setMemberInfo);
    }
  }, [isAuth]);

  useEffect(() => {
    const handleScroll = () => setIsSticky(window.scrollY > 100);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <StyledHeader className={classnames('fixed-top', isSticky && 'sticky')}>
      <Navbar expand="lg" className="bg-transparent">
        <Container fluid="lg">
          <Navbar.Brand href="/">
            <img src={logo} alt="Matsutek" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="matsutek-navbar-nav" />
          <Navbar.Offcanvas id="matsutek-navbar-nav">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id="offcanvasNavbarLabel-expand-lg">選單</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="mx-auto">
                <RenderGreeting isAuth={isAuth} memberInfo={memberInfo} />
                <Nav.Link href="/announcement">
                  公告訊息
                  <RenderUnreadBadge unreadStatus={unreadStatus} type="公告" />
                </Nav.Link>
                {isAuth && <Nav.Link href="/battery">我的電池</Nav.Link>}
                <Nav.Link href="/activity">最新活動</Nav.Link>
                <NavDropdown title="會員專區" id="matsutek-nav-dropdown">
                  {isAuth ? (
                    <>
                      <NavDropdown.Item href="/member/profile">
                        資料修改
                      </NavDropdown.Item>
                      <NavDropdown.Item href="/notice">
                        用戶通知
                        <RenderUnreadBadge unreadStatus={unreadStatus} type="通知" />
                      </NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item onClick={handleLogout}>登出</NavDropdown.Item>
                    </>
                  ) : (
                    <>
                      <NavDropdown.Item href="/register">註冊</NavDropdown.Item>
                      <NavDropdown.Item href="/login">登入</NavDropdown.Item>
                    </>
                  )}
                </NavDropdown>
                <Nav.Link href="https://www.matsutek.com/" target="_blank">松騰官網</Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </StyledHeader>
  );
};

const StyledHeader = styled.header`
  transition: background-color 0.5s;
  &.sticky, &:hover {
    background-color: ${colors.white};
  }
  .navbar {
    padding: 1rem 0;
  }
  .navbar-brand img {
    width: 186px;
    ${breakpoints.down_md} {
      width: 32vw;
    }
  }
  .navbar-toggler {
    border: 0;
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
  .navbar-collapse {
    padding-right: 186px;
  }
  #matsutek-navbar-nav {
    .nav-link {
      margin-left: 1.5rem;
      &:hover {
        color: ${colors.primary}};
      }
    } 
  }
  .dropdown-menu{
    font-size: 0.875rem;
    padding: .5rem 0;
    border-radius: 2px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
    .dropdown-item {
      padding: .5rem 1.5rem;
    }
  }
  .red-point {
    display: inline-block;
    width: 5px;
    height: 5px;
    background-color: ${colors.danger};
    border-radius: 50%;
    margin-left: 4px;
  }
`;

const StyledGreeting = styled.span`
  display: inline-block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  ${breakpoints.up_md} {
    margin-left: 1.5rem;
  }
`

export default Header;
